// extracted by mini-css-extract-plugin
export var marginNegative = "_5z-5 _5z-3 _5z-1";
export var marginPositive = "_5z-4 _5z-3 _5z-1";
export var modalContent = "_5z-6";
export var samplesTable = "_5z-8";
export var samplesTableContainer = "_5z-7";
export var statBox = "_5z-a";
export var tableCell = "_5z-1";
export var tableCellCenter = "_5z-2 _5z-1";
export var tableCellRight = "_5z-3 _5z-1";
export var tableHeader = "_5z-0";
export var trackingNumber = "_5z-9";